import axios from "axios";

// Define action types
export const FETCH_COURSE_REQUEST = "FETCH_COURSE_REQUEST";
export const FETCH_COURSE_SUCCESS = "FETCH_COURSE_SUCCESS";
export const FETCH_COURSE_FAILURE = "FETCH_COURSE_FAILURE";

export const DELETE_COURSE_REQUEST = "DELETE_COURSE_REQUEST";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILURE = "DELETE_COURSE_FAILURE";

export const DELETE_DATE_REQUEST = "DELETE_DATE_REQUEST";
export const DELETE_DATE_SUCCESS = "DELETE_DATE_SUCCESS";
export const DELETE_DATE_FAILURE = "DELETE_DATE_FAILURE";

// Action to fetch courses from the API
export const fetchCourses = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_COURSE_REQUEST }); // Log loading state

  try {
    const token = localStorage.getItem('sassoontoken');
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/allcourses`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );


    const username = getState().auth.user?.username;
    const filterRegion = username === "ukadmin" ? "uk" : "us";

    const filteredCourses = response.data.filter(
      (course) => course.region === filterRegion
    );

    dispatch({
      type: FETCH_COURSE_SUCCESS,
      payload: filteredCourses || [],
    });
  } catch (error) {
    console.error("Error fetching courses:", error);

    dispatch({
      type: FETCH_COURSE_FAILURE,
      payload: error.message || "Failed to fetch courses",
    });
  }
};

export const deleteCourse = (courseId) => async (dispatch) => {
  dispatch({ type: DELETE_COURSE_REQUEST });
  try {
    const token = localStorage.getItem('sassoontoken');
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/course/${courseId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({ type: DELETE_COURSE_SUCCESS, payload: courseId });
    dispatch(fetchCourses());
  } catch (error) {
    dispatch({ 
      type: DELETE_COURSE_FAILURE,
      payload: error.response?.data?.message || "Failed to delete course"
    });
  }
};

export const deleteDate = (dateId) => async (dispatch) => {
  dispatch({ type: DELETE_DATE_REQUEST });
  try {
    const token = localStorage.getItem('sassoontoken');
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/date/${dateId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({ type: DELETE_DATE_SUCCESS, payload: dateId });
    dispatch(fetchCourses());
  } catch (error) {
    dispatch({ 
      type: DELETE_DATE_FAILURE,
      payload: error.response?.data?.message || "Failed to delete date"
    });
  }
};

